import {
    apiCallingFailure,
    apiCallingStart,
    login,
    signOut,
    signUp,
    setUser,
    setUserSession,
    setChangePassword,
    defaultCalling,
    userUpdate,
    setUsers,
    userRoles,
} from '../Reducers/userReducers';
import { apiRequest } from '../../common/common';

const userSignUp = user => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('post', '/register', {
            first_name: user.firstName,
            last_name: user.lastName,
            email: user.email,
            phone_number: user.phoneNumber,
            org_name: user.organizationName,
            org_type: user.orgType,
            org_website: user.orgWebsite,
            organization_id: user?.organizationId
        });
        if (response?.data) {
            dispatch(signUp(response.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
};

const userLogin = user => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('post', '/login', {
            email: user.email,
            password: user.password
        });
        if (response?.data) {
            dispatch(login(response.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
}

const userSignOut = () => async dispatch => {
    dispatch(apiCallingStart());
    try {
        dispatch(signOut());
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
}

const getUserByToken = () => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('get', '/users/me');
        if (response?.data) {
            dispatch(setUser(response.data));
        }
        const res = await apiRequest('get', '/users/roles');
        if (res?.data) {
            dispatch(userRoles(res.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
}

const getUsers = (organizationId) => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const url = [
            `/org-admin/users?organizationId=${organizationId}`,
            `pageNo=1`,
            `pageSize=100`
        ]
            .filter(Boolean)  // Filters out empty strings
            .join('&');
        const response = await apiRequest('get', url);
        if (response?.data) {
            dispatch(setUsers(response.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
}

const setSession = token => async dispatch => {
    dispatch(apiCallingStart());
    try {
        dispatch(setUserSession(token));
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
}

const changePassword = user => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('post', '/users/change-password', user);
        if (response?.data) {
            dispatch(setChangePassword(response.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
}

const defaultApiCall = () => async dispatch => {
    dispatch(defaultCalling());
}

const updateUser = user => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('put', `/users/${user.userId}`, {
            first_name: user.firstName,
            email: user?.email,
            last_name: user.lastName,
            phone_number: user.phoneNumber,
        });
        if (response?.data) {
            dispatch(userUpdate(response.data));
            dispatch(getUserByToken());
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.status || error.message));
    }
};

export {
    userSignUp,
    userLogin,
    userSignOut,
    getUserByToken,
    setSession,
    changePassword,
    defaultApiCall,
    updateUser,
    getUsers,
};
